import React from "react";

import StakeV2 from "./StakeV2";

export default function Stake(props) {
  return <StakeV2 {...props} /> ;
}
